import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";

const BRAND = "Matchpoint Intelligence";

const HomePage = () => {
  const { t } = useTranslation("public");
  const navigate = useNavigate();

  const handleB2BClick = () => navigate("/b2b/login");
  const handleModeratorClick = () => navigate("/moderator/login");

  return (
    <div className="home-page">
      <div className="home-page__background" />

      <div className="container">
        <div className="home-page__inner">
          <header className="home-page__header">
            <h1 className="home-page__title">{t("home.title", { brand: BRAND })}</h1>
            <p className="home-page__subtitle">{t("home.subtitle")}</p>
          </header>

          <section className="home-page__grid" aria-label={t("home.gridLabel", { brand: BRAND })}>
            {/* Matchpoint Intelligence card */}
            <article className="platform-card platform-card--primary">
              <div className="platform-card__icon-wrapper">
                <div className="platform-card__icon">
                  <span className="platform-card__icon-glyph" aria-hidden="true">
                    {/* Simple document icon using CSS shapes; glyph as fallback */}▤
                  </span>
                </div>
              </div>

              <div className="platform-card__content">
                <h2 className="platform-card__title">{BRAND}</h2>
                <p className="platform-card__description">{t("home.b2b.description", { brand: BRAND })}</p>

                <ul className="platform-card__features">
                  <li className="platform-card__feature">{t("home.b2b.features.matchmaking")}</li>
                  <li className="platform-card__feature">{t("home.b2b.features.products")}</li>
                  <li className="platform-card__feature">{t("home.b2b.features.trust")}</li>
                  <li className="platform-card__feature">{t("home.b2b.features.market")}</li>
                </ul>
              </div>

              <div className="platform-card__actions">
                <button
                  type="button"
                  className="platform-card__button platform-card__button--primary"
                  onClick={handleB2BClick}
                >
                  {t("home.b2b.cta", { brand: BRAND })}
                </button>
              </div>
            </article>

            {/* Moderator Platform card */}
            <article className="platform-card platform-card--secondary">
              <div className="platform-card__icon-wrapper">
                <div className="platform-card__icon platform-card__icon--dark">
                  <span className="platform-card__icon-glyph" aria-hidden="true">
                    ⚑
                  </span>
                </div>
              </div>

              <div className="platform-card__content">
                <h2 className="platform-card__title">{t("home.moderator.title")}</h2>
                <p className="platform-card__description">{t("home.moderator.description")}</p>

                <ul className="platform-card__features">
                  <li className="platform-card__feature">{t("home.moderator.features.deals")}</li>
                  <li className="platform-card__feature">{t("home.moderator.features.vetting")}</li>
                  <li className="platform-card__feature">{t("home.moderator.features.communication")}</li>
                  <li className="platform-card__feature">{t("home.moderator.features.leads")}</li>
                </ul>
              </div>

              <div className="platform-card__actions">
                <button
                  type="button"
                  className="platform-card__button platform-card__button--secondary"
                  onClick={handleModeratorClick}
                >
                  {t("home.moderator.cta")}
                </button>
              </div>
            </article>
          </section>

          <footer className="home-page__footer">
            <p className="home-page__footer-text">{t("copyright", { year: 2026, brand: BRAND })}</p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
